import { Component, ViewChild, OnInit, Injectable, Input } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MdPaginator } from "@angular/material";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";
import { AuthService } from "../../../../../services/auth.service";
import { ComponentInterface } from "../../models/component.interface";
import { DocumentModel } from "../../../../../models/documents/document.model";
import { DashboardService } from "../../../../../services/dashboard.service";

import { saveAs } from "file-saver";

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.css"],
})
export class DocumentsComponent implements OnInit, ComponentInterface {
  @Input() config;

  displayedColumns = ["name", "dataUpload", "download"];
  // displayedColumns = ["name", "link", "dataUpload", "download"];
  dataSource: DocumentsDataSource = null;
  isLoading: boolean = false;
  rowCount: number = 0;
  data: DocumentModel[] = null;
  downloads: DocumentModel[] = null;
  title: string = "";
  subtitle: string;

  constructor(
    private _dashboardService: DashboardService,
    public _authService: AuthService
  ) {
    //this.dataSource = new IncassiInLavorazioneDataSource(this._incassiService, this.paginator);
  }

  @ViewChild(MdPaginator) paginator: MdPaginator;

  ngOnInit() {
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
        this.isLoading = false;
        this.rowCount = blocco.blocchiToDOWNLOAD.length;
        this.dataSource = new DocumentsDataSource(
          blocco.blocchiToDOWNLOAD,
          this.paginator
        );
        this.downloads = blocco.blocchiToDOWNLOAD;
        this.isLoading = false;
      });
  }

  downloadFile(item) {
    this._dashboardService.downloadFile(item.downloadSrc).subscribe((file) => {
      saveAs(file, item.downloadTesto);
    });
  }
}

export class DocumentsDataSource extends DataSource<any> {
  constructor(
    //private _incassiService: IncassiService,
    private data: DocumentModel[],
    private _paginator: MdPaginator
  ) {
    super();
  }

  connect(): Observable<DocumentModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/documents/documents.component.ts